import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';

const CreateMenuDialog = ({
  open,
  onClose,
  newMenuName,
  setNewMenuName,
  handleCreateAndAddToMenu,
  handleKeyPress
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: { width: { xs: '95%', sm: '100%' }, mx: 'auto', borderRadius: { xs: 2, sm: 1 } }
      }}
    >
      <DialogTitle sx={{ py: { xs: 2, sm: 1.5 }, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
        Create New Cocktail Menu
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <TextField
          autoFocus
          margin="dense"
          label="Menu Name"
          fullWidth
          value={newMenuName}
          onChange={(e) => setNewMenuName(e.target.value)}
          onKeyPress={handleKeyPress}
          sx={{ '& .MuiInputBase-root': { borderRadius: { xs: 2, sm: 1 } } }}
        />
      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, sm: 1.5 } }}>
        <Button onClick={onClose} sx={{ minWidth: { xs: '80px', sm: '64px' } }}>
          Cancel
        </Button>
        <Button 
          onClick={handleCreateAndAddToMenu} 
          color="primary" 
          variant="contained" 
          sx={{ minWidth: { xs: '80px', sm: '64px' } }}
          disabled={!newMenuName.trim()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateMenuDialog; 